import React, {useState} from "react";
import {useForm} from "react-hook-form";
import PageFields from "./PageFields";

export default function () {
  const {register, handleSubmit, reset, control, watch} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const pageFields = <PageFields {...{register, errors, control, data, watch}} />;

  return {
    setErrors,
    pageFields,
    handleSubmit,
    reset,
    setData,
  }
}